/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassEnrollDeleteRequest
 */
export interface ClassEnrollDeleteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassEnrollDeleteRequest
     */
    studentIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollDeleteRequest
     */
    classId: string;
}

/**
 * Check if a given object implements the ClassEnrollDeleteRequest interface.
 */
export function instanceOfClassEnrollDeleteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "studentIds" in value;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function ClassEnrollDeleteRequestFromJSON(json: any): ClassEnrollDeleteRequest {
    return ClassEnrollDeleteRequestFromJSONTyped(json, false);
}

export function ClassEnrollDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassEnrollDeleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'studentIds': json['studentIds'],
        'classId': json['classId'],
    };
}

export function ClassEnrollDeleteRequestToJSON(value?: ClassEnrollDeleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'studentIds': value.studentIds,
        'classId': value.classId,
    };
}

